/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import AddIdentifiers from "./AddIdentifiers";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import Button from "./Button";
import SwitchLabels from "./Switchlabel";
import MultilineText from "./MultilineText";
import PasswordInput from "./PasswordInput";
import MultipleSelect from "./MultipleSelectBox";
import SearchableSelectBox from "./SearchableSelectBox";
import MultiSelectCheckBox from "./MultiSelectCheckBox";
import TimePicker from "./Time";
import TimeStartToEnd from "./TimeStartToEnd";
import DateTime from "./DateTime";
import TextContent from "./TextContent";
import QRCode from './QRCode';
import QRCodeUpload from './QRCodeUpload';
import ImageUpload from './ImageUpload';
import CustomInput from './CustomInput';
import MultilineTextWithButton from './MultilineTextWithButton';
import Formio from '../FormsControls/Formio/FormioApp';
import PreviewBox from "./Formio/PreviewBox";
import Confirmation from './Confirmation';
import FormBrack from './FormBrack';
import RequiredMsg from './RequiredMsg';
import Heading from './Heading';
import DragFileUpload from './DragFileUpload';
import Customer360Search from './Customer360Search';
import Customer360Select from './Customer360Select';
import CheckBoxList from "./CheckBoxList";
import UploadFile from "./UploadFile";
import UploadFileExcel from "./UploadFileExcel";
import DragDrapSelect from "./DragDropSelect/index";
import ScrubRule from "./ScrubRule";
import ButtonSelect from "./ButtonSelect";
import BtnGroup from "./ButtonGroup";
import SubForm from "./SubForm";
import NestedRender from "./NestedRender";
import NestedAddRowRender from "./NestedAddRowRender";
import RateSheetAddRow from "./RateSheetAddRow";
import FileUpload from "./FileUpload";
import RoutingInfo from "./RoutingInfo";
import VosGatewayInfo from "./VosGatewayInfo";
const Controls = {
    Input,
    RadioGroup,
    Select,
    AddIdentifiers,
    Checkbox,
    DatePicker,
    Button,
    SwitchLabels,
    MultilineText,
    PasswordInput,
    MultipleSelect,
    SearchableSelectBox,
    MultiSelectCheckBox,
    TimePicker,
    TimeStartToEnd,
    TextContent,
    QRCode,
    QRCodeUpload,
    ImageUpload,
    CustomInput,
    MultilineTextWithButton,
    Formio,
    PreviewBox,
    DateTime,
    Confirmation,
    FormBrack,
    DragFileUpload,
    Customer360Search,
    Customer360Select,
    CheckBoxList,
    UploadFile,
    DragDrapSelect,
    Heading,
    ScrubRule,
    ButtonSelect,
    BtnGroup,
    UploadFileExcel,
    RequiredMsg,
    SubForm,
    NestedRender,
    NestedAddRowRender,
    RateSheetAddRow,
    FileUpload,
    RoutingInfo,
    VosGatewayInfo
}

export default Controls;